export const status = [
  {
    display: "Active",
    value: "active"
  },
  {
    display: "Not Active",
    value: "inActive"
  }
]